import { useContext, createContext, useEffect, useState } from "react";

// Importaciones correctas de CASL

import defineAbilityFor from "../ability";

// Crear y exportar el contexto de habilidades
export const AbilityContext = createContext();

export const useAbility = () => {
    const context = useContext(AbilityContext);
    if (!context) {
        throw new Error('useAbility must be used within an AbilityProvider');
    }
    return context;
}

export const AbilityProvider = ({ children }) => {
    const [ability, setAbility] = useState(() => {
        const userAuth = JSON.parse(localStorage.getItem('authUser')) || {};
        return defineAbilityFor(userAuth);
    });

    useEffect(() => {
        // Function to update ability based on localStorage
        const updateAbility = () => {
            const userAuth = JSON.parse(localStorage.getItem('authUser')) || {};
            const newAbility = defineAbilityFor(userAuth);
            
            // Solo actualizar si los permisos han cambiado realmente
            const currentPermissions = JSON.stringify(ability.rules);
            const newPermissions = JSON.stringify(newAbility.rules);
            
            if (currentPermissions !== newPermissions) {
                setAbility(newAbility);
            }
        };

        // Add event listener for storage changes
        window.addEventListener('storage', updateAbility);

        // Also watch for direct localStorage changes in the same window
        const checkAuthInterval = setInterval(updateAbility, 1000);

        return () => {
            window.removeEventListener('storage', updateAbility);
            clearInterval(checkAuthInterval);
        };
    }, [ability]); // Necesitamos ability aquí para comparar los permisos actuales

    return <AbilityContext.Provider value={ability}>{children}</AbilityContext.Provider>;
}


